(function ($) {

    const basket_modal = new bootstrap.Modal('#modal-basket', {});

    $(document).on('click', '.single_add_to_cart_button', function (e) {
        e.preventDefault();

        let $thisbutton = $(this),
            $form = $thisbutton.closest('form.cart'),
            id = $thisbutton.val(),
            product_qty = $form.find('input[name=quantity]').val() || 1,
            product_id = $form.find('input[name=product_id]').val() || id,
            variation_id = $form.find('input[name=variation_id]').val() || 0,
            product_details = $thisbutton.parents('.product-details'),
            bundles = product_details.find('.product-bundle-card');

        if($thisbutton.is('.bundle_add_to_cart_button')){
            product_id = $thisbutton.attr('value');
            variation_id = 0;
        }

        let data = {
            action: 'woocommerce_ajax_add_to_cart',
            product_id: product_id,
            product_sku: '',
            quantity: product_qty,
            variation_id: variation_id,
            bundles: []
        };

        // can be added or not
        if($thisbutton.is('.disabled')){
            return false;
        }

        bundles.each(function (){
            let bundle = $(this),
                checkbox = bundle.find('.product-bundle-card__checkbox'),
                bundle_id = parseInt(checkbox.attr('data-product_id'));

            if(checkbox.is(':checked')){
                data.bundles.push(bundle_id);
            }
        });

        $(document.body).trigger('adding_to_cart', [$thisbutton, data]);

        $.ajax({
            type: 'post',
            url: wc_add_to_cart_params.ajax_url,
            data: data,
            beforeSend: function (response) {
                $thisbutton.removeClass('added').addClass('loading');
            },
            complete: function (response) {
                $thisbutton.addClass('added').removeClass('loading');
            },
            success: function (response) {
                if (response.error && response.product_url) {
                    console.log(response);
                } else {
                    $(document.body).trigger('added_to_cart', [response.fragments, response.cart_hash, $thisbutton]);
                }
            },
        });

        return false;
    });

    // show basket popup after added to cart
    $('body').on('added_to_cart', function (e, fragment){
        basket_modal.show();
    });

    $('#shopping-cart-link').on('click', function (e){
        e.preventDefault();
        basket_modal.show();
    });
})(jQuery);